import Vue from 'vue'
import VueRouter from 'vue-router'
import shoph5 from './modules/shoph5'
import myShop from './modules/myShop'

Vue.use(VueRouter)

const routes = [
  {
    path: '/shopList',
    name: 'shopList',
    component: () => import('../views/shopList.vue'),
    meta: { title: '店铺列表', icon: 'user' }
  },
  {
    path: '/goodList',
    name: 'goodList',
    component: () => import('../views/goodList.vue'),
    meta: { title: '商品列表', icon: 'user' }
  },
  {
    path: '/goodsCategory',
    name: 'goodsCategory',
    component: () => import('../views/goodsCategory.vue'),
    meta: { title: '商品类别', icon: 'user' }
  },
  {
    path: '/orderList',
    name: 'orderList',
    component: () => import('../views/orderList.vue'),
    meta: { title: '订单信息', icon: 'user' }
  },
  {
    path: '/monthOrderList',
    name: 'monthOrderList',
    component: () => import('../views/monthOrderList.vue'),
    meta: { title: '月结订单', icon: 'user' }
  },
  {
    path: '/receivingAddress/list',
    name: 'receivingAddress',
    component: () => import('../views/receivingAddress/list.vue'),
    meta: { title: '收货地址', icon: 'user' }
  },
  {
    path: '/receivingAddress/detail/:id',
    name: 'receivingAddressDetail',
    component: () => import('../views/receivingAddress/detail.vue'),
    meta: { title: '收货地址', icon: 'user' }
  },
  shoph5, myShop
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
